import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  Box,
  Button,
  Checkbox,
  Divider,
  Paper,
  Typography,
} from '@material-ui/core'

import InventoryItemCard from '../AiInventoryDaiChat/components/InventoryItemCard'

import useStyles from './styles'

const AiInventoryDaiReview = ({
  items,
  confirmed,
  onConfirmChange,
  onBack,
  onConclude,
  loading = false,
  fullBleed = false,
  showRisk = true,
}) => {
  const classes = useStyles()
  const [collapsedIds, setCollapsedIds] = useState([])

  const handleToggle = (itemId) => (_, isExpanded) =>
    setCollapsedIds((current) =>
      isExpanded ? current.filter((id) => id !== itemId) : [...current, itemId],
    )

  return (
    <Box className={clsx(classes.wrapper, { [classes.fullBleed]: fullBleed })}>
      <Paper variant="outlined" className={classes.paper}>
        <Box className={classes.header}>
          <Typography variant="h5" className={classes.title}>
            Revisão do inventário de IA
          </Typography>
          <Typography variant="body2" className={classes.subtitle}>
            Confira as IAs cadastradas e confirme a veracidade antes de
            concluir.
          </Typography>
        </Box>

        <Divider />

        <Box className={classes.content}>
          {items.map((item) => (
            <InventoryItemCard
              key={item.id}
              item={item}
              expanded={!collapsedIds.includes(item.id)}
              onChange={handleToggle(item.id)}
              showRisk={showRisk}
            />
          ))}

          <Box className={classes.confirmBox}>
            <Checkbox
              color="primary"
              checked={confirmed}
              onChange={(event) => onConfirmChange(event.target.checked)}
            />
            <Box>
              <Typography variant="subtitle1" className={classes.confirmTitle}>
                Confirmação de veracidade no cadastro de IA
              </Typography>
              <Typography variant="body2" className={classes.confirmText}>
                Ao confirmar, você declara que as informações acima são
                verdadeiras e assume responsabilidade pelo uso ético e adequado
                desta inteligência artificial, em conformidade com as políticas
                internas da organização.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>

      <Box className={classes.actions}>
        <Button variant="outlined" onClick={onBack} disabled={loading}>
          Voltar e editar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onConclude}
          disabled={!confirmed || loading}
        >
          Concluir cadastro
        </Button>
      </Box>
    </Box>
  )
}

AiInventoryDaiReview.propTypes = {
  items: PropTypes.array.isRequired,
  confirmed: PropTypes.bool.isRequired,
  onConfirmChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onConclude: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  fullBleed: PropTypes.bool,
  showRisk: PropTypes.bool,
}

export default AiInventoryDaiReview
